import React from 'react';

const WhyUs = () => {
  return (
    <section className="sec why" id="why">
      <div className="wrap">
        <div className="rev">
          <div className="ey">Why SSRR Labs</div>
          <h2>Built different.<br/><i>Delivered different.</i></h2>
        </div>
        <div className="why-grid">
          <div className="why-points">
            <div className="why-pt rev">
              <span className="wp-n">01</span>
              <div>
                <div className="wp-title">AI-Native From the Ground Up</div>
                <p className="wp-text">We did not retrofit AI into existing processes. Every product and engagement is designed around intelligent automation from day one — not as a feature added later.</p>
              </div>
            </div>
            <div className="why-pt rev">
              <span className="wp-n">02</span>
              <div>
                <div className="wp-title">Deep Domain Expertise</div>
                <p className="wp-text">Finance, e-commerce, banking and human-centric apps are not peripheral — they are our core. We bring genuine industry knowledge, not generic technology solutions applied to unfamiliar problems.</p>
              </div>
            </div>
            <div className="why-pt rev">
              <span className="wp-n">03</span>
              <div>
                <div className="wp-title">Founder-Led Accountability</div>
                <p className="wp-text">Every engagement is led by founding leadership. No handoffs to junior teams. The people who built this company work directly on your challenges.</p>
              </div>
            </div>
            <div className="why-pt rev">
              <span className="wp-n">04</span>
              <div>
                <div className="wp-title">Global Perspective, Local Understanding</div>
                <p className="wp-text">Operating across multiple markets gives us a perspective that single-market companies simply do not have. We understand how AI products succeed globally — not just locally.</p>
              </div>
            </div>
            <div className="why-pt rev">
              <span className="wp-n">05</span>
              <div>
                <div className="wp-title">Outcome Obsessed</div>
                <p className="wp-text">We measure success by what changes in your business — not deliverables shipped or hours billed. Our reputation depends entirely on your results.</p>
              </div>
            </div>
          </div>

          <div className="why-right">
            <div className="why-code rev d1">
              <div className="wc-bar">
                <div className="wc-dot" style={{ background: '#ff5f57' }}></div>
                <div className="wc-dot" style={{ background: '#febc2e' }}></div>
                <div className="wc-dot" style={{ background: '#28c840' }}></div>
              </div>
              <div className="wc-body">
                <span className="cm">{"// "}SSRR Labs — Core Belief</span><br/><br/>
                <span className="kw">const</span> mission = {'{'}<br/>
                &nbsp;&nbsp;build: <span className="str">"AI that helps everyone"</span>,<br/>
                &nbsp;&nbsp;domains: [<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className="str">"finance"</span>,<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className="str">"e-commerce"</span>,<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className="str">"banking"</span>,<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className="str">"human-centric"</span><br/>
                &nbsp;&nbsp;],<br/>
                &nbsp;&nbsp;approach: <span className="str">"outcomes first"</span>,<br/>
                &nbsp;&nbsp;scale: <span className="str">"global"</span><br/>
                {'}'}<br/><br/>
                <span className="fn">ssrrLabs</span>.<span className="kw">launch</span>(mission) <span className="cm">{"// "}2026</span>
              </div>
            </div>
            <div className="why-meta rev d2">
              <div className="wm-item">
                <div className="wm-num">10<span>+</span></div>
                <div className="wm-label">AI Products In Active Development</div>
              </div>
              <div className="wm-item">
                <div className="wm-num">4</div>
                <div className="wm-label">Core Domain Verticals</div>
              </div>
              <div className="wm-item">
                <div className="wm-num">∞</div>
                <div className="wm-label">Problems Worth Solving</div>
              </div>
              <div className="wm-item">
                <div className="wm-num">1<span>st</span></div>
                <div className="wm-label">Principle: AI For Everyone</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;